import urlJoin from 'url-join';
import { AppSettings } from 'core/AppSettings';

export const HUB_SOURCE_PARAM = 'ideagen_hub_source';
export const HUB_LOGIN_PATH = '/security/hub-login';
const RETURN_URL_PARAM = 'ReturnUrl';

export function hasHubSourceMarker(): boolean {
  const params = new URLSearchParams(window.location.search);
  return params.get(HUB_SOURCE_PARAM)?.toLowerCase() === 'true';
}

// Must target the API host, not the SPA origin: the omnis host is a static CDN that serves every
// path as index.html, so a same-origin hub-login URL re-renders the SPA instead of hitting the
// backend. ReturnUrl must be absolute; the backend's RedirectUrlValidator rejects relative values.
export function getHubLoginUrl(): string {
  const returnUrl = getReturnUrl();
  return `${urlJoin(getHubLoginHost(), HUB_LOGIN_PATH)}?${HUB_SOURCE_PARAM}=true&ReturnUrl=${encodeURIComponent(returnUrl)}`;
}

function getHubLoginHost(): string {
  const host = AppSettings.cumulusApiUrl;
  return host.startsWith('http') ? host : `https://${host}`;
}

function getReturnUrl(): string {
  const candidate = buildCleanUrl();
  if (isHubLoginPath(new URL(candidate).pathname)) {
    return getExistingReturnUrl();
  }
  return candidate;
}

function buildCleanUrl(): string {
  const url = new URL(window.location.href);
  url.searchParams.delete(HUB_SOURCE_PARAM);
  const search = url.searchParams.toString();
  return `${url.origin}${url.pathname}${search ? `?${search}` : ''}${url.hash}`;
}

function getExistingReturnUrl(): string {
  const params = new URLSearchParams(window.location.search);
  const existing = params.get(RETURN_URL_PARAM);
  return existing || window.location.origin;
}

function isHubLoginPath(pathname: string): boolean {
  return pathname.toLowerCase() === HUB_LOGIN_PATH;
}
